export const certifications = {
  "en-US": [
    {
      institution: "Alura",
      title: "React Native Course",
      duration: "86 hours",
      credential:
        "https://unibb.alura.com.br/degree/certificate/264344d9-7fc6-4835-89c0-f3162d2eac3c?lang",
    },
    {
      institution: "Alura",
      title: "JS for Backend Training",
      duration: "76 hours",
      certificate: "JavaScript for Backend Training.pdf",
      credential:
        "https://unibb.alura.com.br/degree/certificate/1bb6b72c-637e-41e4-b176-1bff03c446c3",
    },
    {
      institution: "Alura",
      title: "Angular Course",
      duration: "56 hours",
      credential:
        "https://unibb.alura.com.br/degree/certificate/6520b5a2-201f-46e8-ad51-360f7f19aaad?lang",
    },
    {
      institution: "Alura",
      title: "TDD and Java",
      duration: "8 hours",
      certificate: "TDD and Java Automated Testing with JUnit.pdf",
    },
  ],

  "pt-BR": [
    {
      institution: "Alura",
      title: "Curso de React Native",
      duration: "86 horas",
      credential:
        "https://unibb.alura.com.br/degree/certificate/264344d9-7fc6-4835-89c0-f3162d2eac3c?lang",
    },
    {
      institution: "Alura",
      title: "Formação JS para Backend",
      duration: "76 horas",
      certificate: "JavaScript para Backend.pdf",
      credential:
        "https://unibb.alura.com.br/degree/certificate/1bb6b72c-637e-41e4-b176-1bff03c446c3",
    },
    {
      institution: "Alura",
      title: "Curso de Angular",
      duration: "56 horas",
      credential:
        "https://unibb.alura.com.br/degree/certificate/6520b5a2-201f-46e8-ad51-360f7f19aaad?lang",
    },
    {
      institution: "Alura",
      title: "TDD e Java",
      duration: "8 horas",
      certificate: "TDD e Java Testes Automatizados com JUnit.pdf",
    },
  ],

   "es-ES": [
    {
      institution: "Alura",
      title: "Curso de React Native",
      duration: "86 horas",
      credential:
        "https://unibb.alura.com.br/degree/certificate/264344d9-7fc6-4835-89c0-f3162d2eac3c?lang",
    },
    {
      institution: "Alura",
      title: "Formación JS para Backend",
      duration: "76 horas",
      certificate: "JavaScript para Backend.pdf",
      credential:
        "https://unibb.alura.com.br/degree/certificate/1bb6b72c-637e-41e4-b176-1bff03c446c3",
    },
    {
      institution: "Alura",
      title: "Curso de Angular",
      duration: "56 horas",
      credential:
        "https://unibb.alura.com.br/degree/certificate/6520b5a2-201f-46e8-ad51-360f7f19aaad?lang",
    },
    {
      institution: "Alura",
      title: "TDD y Java",
      duration: "8 horas",
      certificate: "TDD y Java Pruebas Automatizadas con JUnit.pdf",
    },
  ]
};
